import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    Alert,
    Button,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import HeaderBar from "../components/HeaderBar";
import themeColors from "../theme";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useAuth } from "../context/AuthContext";

export default function RegisteredUsersPage() {
    const navigate = useNavigate();
    const { token } = useAuth();
    const { teal, lightGray } = themeColors;
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_SERVER_URL}/api/admin/users`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setUsers(res.data?.users ?? []);
            } catch (err) {
                setError(err.response?.data?.error || "Failed to load users.");
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box sx={{ minHeight: "100vh", backgroundColor: lightGray }}>
            <HeaderBar />
            <Box sx={{ px: { xs: 2, md: 8 }, py: 6, maxWidth: "1200px", mx: "auto" }}>
                <Button
                    startIcon={<ArrowBackIosNewIcon />}
                    onClick={() => navigate("/admin")}
                    sx={{ mb: 2, color: teal }}
                >
                    Back to Admin
                </Button>
                <Typography variant="h4" fontWeight="bold" color="#2C3E50" mb={1}>
                    Registered users
                </Typography>
                <Typography variant="body1" color="#6C757D" mb={4}>
                    All users registered in the system.
                </Typography>

                {loading && (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                        <CircularProgress sx={{ color: teal }} />
                    </Box>
                )}
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
                {!loading && !error && (
                    <TableContainer component={Paper}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ backgroundColor: teal, color: "white", fontWeight: 600 }}>Name</TableCell>
                                    <TableCell sx={{ backgroundColor: teal, color: "white", fontWeight: 600 }}>Email</TableCell>
                                    <TableCell sx={{ backgroundColor: teal, color: "white", fontWeight: 600 }}>Doctor type</TableCell>
                                    <TableCell sx={{ backgroundColor: teal, color: "white", fontWeight: 600 }}>State(s)</TableCell>
                                    <TableCell sx={{ backgroundColor: teal, color: "white", fontWeight: 600 }}>Resident</TableCell>
                                    <TableCell sx={{ backgroundColor: teal, color: "white", fontWeight: 600 }}>Residency program</TableCell>
                                    <TableCell sx={{ backgroundColor: teal, color: "white", fontWeight: 600 }}>NPI verified</TableCell>
                                    <TableCell sx={{ backgroundColor: teal, color: "white", fontWeight: 600 }}>Email verified</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                                            No registered users.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    users.map((u) => (
                                        <TableRow key={u.id} hover>
                                            <TableCell>{u.name}</TableCell>
                                            <TableCell>{u.email}</TableCell>
                                            <TableCell>{u.designation}</TableCell>
                                            <TableCell>{u.states}</TableCell>
                                            <TableCell>{u.resident ? "Yes" : "No"}</TableCell>
                                            <TableCell>{u.program}</TableCell>
                                            <TableCell>{u.npiVerified ? "Yes" : "No"}</TableCell>
                                            <TableCell>{u.emailVerified ? "Yes" : "No"}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </Box>
    );
}
